import * as _api from './api';

export const api = _api;